import { graphql, useStaticQuery } from 'gatsby';

const useLatestBlogPostsQuery = () => {
  const data = useStaticQuery(graphql`
    query LatestBlogPostsQuery {
      allWpPost(
        filter: {categories: {nodes: {elemMatch: {slug: {nin: ["developers", "uncategorized", "whats-new", "all-articles"]}}}}}
        limit: 3
        sort: {date: DESC}
      ) {
        nodes {
          ...BlogCardPost
        }
      }
    }
  `);

  return data?.allWpPost?.nodes || [];
};

export default useLatestBlogPostsQuery;
